import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Employees from "@/pages/Employees";
import Patients from "@/pages/Patients";
import Operations from "@/pages/Operations";
import OperationalDays from "@/pages/OperationalDays";
import OperationalDayDetail from "@/pages/OperationalDayDetail";
import Payments from "@/pages/Payments";
import KPIPage from "@/pages/KPI";
import Finances from "@/pages/Finances";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Instructions from "@/pages/Instructions";
import Funnel from "@/pages/Funnel";
import PriceList from "@/pages/PriceList";
import Recommendations from "@/pages/Recommendations";
import Calls from "@/pages/Calls";
import PatientDetail from "@/pages/PatientDetail";
import DeletedOperations from "@/pages/DeletedOperations";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout><Dashboard /></Layout>
              </ProtectedRoute>
            }
          />
          <Route path="/employees" element={<ProtectedRoute><Layout><Employees /></Layout></ProtectedRoute>} />
          <Route path="/patients" element={<ProtectedRoute><Layout><Patients /></Layout></ProtectedRoute>} />
          <Route path="/patients/:id" element={<ProtectedRoute><Layout><PatientDetail /></Layout></ProtectedRoute>} />
          <Route path="/operations" element={<ProtectedRoute><Layout><Operations /></Layout></ProtectedRoute>} />
          <Route path="/operations/deleted" element={<ProtectedRoute><Layout><DeletedOperations /></Layout></ProtectedRoute>} />
          <Route path="/operational-days" element={<ProtectedRoute><Layout><OperationalDays /></Layout></ProtectedRoute>} />
          <Route path="/operational-days/:id" element={<ProtectedRoute><Layout><OperationalDayDetail /></Layout></ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute><Layout><Payments /></Layout></ProtectedRoute>} />
          <Route path="/kpi" element={<ProtectedRoute><Layout><KPIPage /></Layout></ProtectedRoute>} />
          <Route path="/finances" element={<ProtectedRoute><Layout><Finances /></Layout></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Layout><Reports /></Layout></ProtectedRoute>} />
          <Route path="/funnel" element={<ProtectedRoute><Layout><Funnel /></Layout></ProtectedRoute>} />
          <Route path="/pricelist" element={<ProtectedRoute><Layout><PriceList /></Layout></ProtectedRoute>} />
          <Route path="/recommendations" element={<ProtectedRoute><Layout><Recommendations /></Layout></ProtectedRoute>} />
          <Route path="/calls" element={<ProtectedRoute><Layout><Calls /></Layout></ProtectedRoute>} />
          <Route path="/instructions" element={<ProtectedRoute><Layout><Instructions /></Layout></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
